<template>
	<div>
		<Head :title="form.name" />

		<div class="mb-8 flex max-w-3xl justify-start">
			<Breadcrumbs
				href="/users"
				:parentLabel="__('Users')"
				:childLabel="form.name"
			/>

			<img v-if="user.photo" class="ml-4 block h-8 w-8 rounded-full" :src="user.photo" :alt="user.name" />
		</div>

		<div class="w-full overflow-hidden rounded-md bg-white shadow">
			<form @submit.prevent="update">
				<div class="-mb-8 -mr-6 flex flex-wrap p-8">
					<TextInput
						v-model="form.name" :error="form.errors.name"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:label="__('Name')"
					/>

					<TextInput
						v-model="form.role" :error="form.errors.role"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:label="__('Role')"
					/>

					<TextInput
						v-model="form.phone"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.phone"
						:label="__('Phone')"
					/>

					<TextInput
						v-model="form.email"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.email"
						:label="__('Email')"
					/>

					<TextInput
						v-model="form.password"
						class="w-full pb-8 pr-6 lg:w-1/2"
						type="password"
						autocomplete="new-password"
						:error="form.errors.password"
						:label="__('Password')"
					/>

					<FileInput
						v-model="form.photo"
						type="file"
						class="w-full pb-8 pr-6 lg:w-1/2"
						accept="image/*"
						:error="form.errors.photo"
						:label="__('Photo (128x128 px, transparent png)')"
					/>
				</div>

				<div class="flex items-center border-t border-gray-100 bg-gray-50 px-8 py-4">
					<button
						v-if="!user.deleted_at"
						class="text-red-600 hover:underline"
						tabindex="-1"
						type="button"
						@click="destroy"
					>
						{{ __('Delete') }}
					</button>

					<LoadingButton
						:loading="form.processing"
						class="btn-save ml-auto"
						type="submit"
					>
						{{ __('Update') }}
					</LoadingButton>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import TextInput 	  from '@/Shared/TextInput'
	import FileInput 	  from '@/Shared/FileInput'
	import LoadingButton  from '@/Shared/LoadingButton'
	import Breadcrumbs    from '@/Shared/Breadcrumbs'

	export default {
		components: {
			FileInput,
			Head,
			Breadcrumbs,
			LoadingButton,
			TextInput
		},
		layout: Layout,
		remember: 'form',
		props: {
			user: Object
		},
		data() {
			return {
				form: this.$inertia.form({
					_method: 'put',
					name: this.user.name,
					role: this.user.role,
					phone: this.user.phone,
					email: this.user.email,
					password: '',
					photo: null,
				})
			}
		},
		methods: {
			update() {
				this.form.post(`/users/${ this.user.id }`, {
					onSuccess: () => this.form.reset('password', 'photo'),
				})
			},
			destroy() {
				if (confirm('Är du säker på att du vill ta bort denna användare?')) {
					this.$inertia.delete(`/users/${ this.user.id }`)
				}
			},
			restore() {
				if (confirm('Är du säker på att du vill återställa denna användare?')) {
					this.$inertia.put(`/users/${ this.user.id }/restore`)
				}
			}
		}
	}
</script>
